export default (preselectedItems, field) => ({

    key: '',
    value: '',
    items: {},
    preselectedItems: preselectedItems,
    field: field,

    init() {
        this.resetItems();
    },

    addItem() {
        if (this.key && this.value) {
            this.items[this.key] = this.value;
            this.key = '';
            this.value = '';
        }

        this.key === '' ? this.focusOnKey() : this.focusOnValue();
    },

    editItem(key, value) {
        this.key = key;
        this.value = value;
        this.focusOnValue();
    },

    removeItem(key) {
        delete this.items[key];
        this.focusOnKey();
    },

    resetItems() {
        if (this.preselectedItems) {
            this.items = this.preselectedItems;
        }
    },

    focusOnKey() {
        this.$refs.keyRef.focus();
    },

    focusOnValue() {
        this.$refs.valueRef.focus();
    },
});
